import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    search: '',
    category: [],
    favourite: 0,
    recent: 0,
    customer: null,
    offer: 0,
};

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setCategory: (state, action) => {
            state.category = action.payload;
        },
        removeCategory: (state, action) => {
            state.category = state.category.filter((category) => category !== action.payload);
        },
        clearCategory: (state) => {
            state.category = [];
        },
        setFavourite: (state, action) => {
            state.favourite = action.payload;
        },
        setRecent: (state, action) => {
            state.recent = action.payload;
        },
        setCustomer: (state, action) => {
            state.customer = action.payload;
        },
        setOffer: (state, action) => {
            state.offer = action.payload;
        },
        clearFilters: (state) => {
            state.search = '';
            state.category = [];
            state.favourite = 0;
            state.recent = 0;
            state.offer = 0;
            state.customer = null;
        },
    },
});

export const {
    setSearch,
    setCategory,
    removeCategory,
    clearCategory,
    setFavourite,
    setRecent,
    setCustomer,
    setOffer,
    clearFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;
